import { useMutation } from "@apollo/client/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData } from "@/data";
import { deleteFileMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useDeleteFile = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [deleteFileAction, { loading }] = useMutation(deleteFileMutation);

    const { deleteFilePending: deleteFilePendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const deleteFile = async (id) => {
        try {
            await deleteFileAction({
                onCompleted: () => {
                    dispatch(
                        openAlert(
                            t("messages.deleteMsgs.success", { entity: t("labels.file") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: { id },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${deleteFilePendingToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.deleteMsgs.pending", { entity: t("labels.file") }), {
                    toastId: `${deleteFilePendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return { deleteFile };
};

export default useDeleteFile;
